import { render, staticRenderFns } from "./QualityReportConsistency.vue?vue&type=template&id=7dcabff8&scoped=true"
import script from "./QualityReportConsistency.vue?vue&type=script&lang=js"
export * from "./QualityReportConsistency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcabff8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dcabff8')) {
      api.createRecord('7dcabff8', component.options)
    } else {
      api.reload('7dcabff8', component.options)
    }
    module.hot.accept("./QualityReportConsistency.vue?vue&type=template&id=7dcabff8&scoped=true", function () {
      api.rerender('7dcabff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/pages/QualityReportConsistency.vue"
export default component.exports